var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,_vm._b({tag:"component",staticClass:"landing-page-entry"},'component',_vm.layoutData,false),[_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }